import { render, staticRenderFns } from "./changeCard.vue?vue&type=template&id=8537b8b8&scoped=true"
import script from "./changeCard.vue?vue&type=script&lang=js"
export * from "./changeCard.vue?vue&type=script&lang=js"
import style0 from "./changeCard.vue?vue&type=style&index=0&id=8537b8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8537b8b8",
  null
  
)

export default component.exports